var _defs, _style, _tspan, _tspan2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaviconLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 53",
    width: 31,
    height: 53,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Proposal-Portal-Logo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.23 41.34c-0.81-5.78 1.39-22.07-0.11-33.03 4.3 6 24.6 19.16 27.53 26.91 1.79 4.38 0.34 13.4-8.55 16.81q-0.58 0.21-1.19 0.37-0.6 0.16-1.21 0.27-0.62 0.1-1.24 0.16-0.62 0.05-1.24 0.05h-0.07c-6.55-0.01-11.67-4.29-13.18-8.96l-0.5-1.45c-0.04-0.25-0.14-0.54-0.14-0.58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.86 42.28c-0.71-5.3 1.23-20.27-0.1-30.34 3.81 5.51 21.79 17.6 24.38 24.71 1.58 4.03 0.3 12.31-7.57 15.44q-0.52 0.2-1.05 0.34-0.53 0.15-1.08 0.25-0.54 0.1-1.09 0.15-0.55 0.05-1.11 0.05h-0.05q-1.92 0-3.75-0.57-1.83-0.58-3.4-1.68-1.57-1.11-2.73-2.64-1.15-1.53-1.79-3.34l-0.45-1.34c-0.03-0.23-0.12-0.5-0.12-0.53"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre } \n\t\t.t0 { font-size: 18px;fill: #2e384d;font-weight: bold;font-family: \"Gotham\" } \n\t\t.t1 { font-size: 18px;fill: #2e384d;font-family: \"Gotham\" } \n\t\t.s2 { fill: #e64ddf } \n\t\t.s3 { opacity: .5;fill: #3d0a46 } \n\t\t.s4 { fill: #472e96 } \n\t\t.s5 { fill: #419ad5 } \n\t\t.s6 { opacity: .1;fill: #2e384d } \n\t\t.s7 { opacity: .1;fill: #ffffff } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Group_6671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Proposal_portal"
  }, /*#__PURE__*/React.createElement("text", {
    id: "PROPOSAL ",
    style: {
      transform: "matrix(1,0,0,1,45.393,24)"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t0"
  }, "PROPOSAL \n"))), /*#__PURE__*/React.createElement("text", {
    id: "PORTAL",
    style: {
      transform: "matrix(1,0,0,1,45.393,24)"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t1"
  }, "PORTAL\n"))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Group_6180",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22950",
    className: "s2",
    d: "m43.8 21.8l-22.4 52.1-34.1-34.5 22.4-52.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Group_6205",
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22955",
    className: "s3",
    d: "m39.6 24.4l-19.9 47.7-30.2-31.6 19.8-47.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22949",
    className: "s4",
    d: "m15.2 0c2.6 0 5 1.6 6.1 4.1 1 2.4 0.4 5.3-1.5 7.2-1.9 1.9-4.7 2.4-7.2 1.4-2.4-1-4.1-3.4-4.1-6.1q0.1-1.3 0.6-2.5 0.5-1.2 1.4-2.2 0.9-0.9 2.1-1.4 1.2-0.5 2.6-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22952",
    className: "s5",
    d: "m29.2 42.1q0 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0 0.2l-0.2 1.2c-1.5 5.9-10.7 11.1-18.8 8.1-8.9-3.4-10.3-12.4-8.5-16.8 2.9-7.7 23.2-20.9 27.5-26.9-1.5 11 0.5 27.1 0.1 33.6q0 0.1-0.1 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22954",
    className: "s6",
    d: "m28.6 43.3q0 0.1 0 0.2 0 0.1 0 0.1 0 0.1-0.1 0.2l-0.1 1.1c-1.4 5.2-9.8 9.9-17.3 7.2-8.1-3-9.5-11-7.8-14.9 2.7-6.9 21.3-18.6 25.3-24-1.4 9.8 0.4 24.1 0 29.9q0 0.1 0 0.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_22957",
    className: "s7",
    d: "m18.3 2.7c-0.9-0.7 4.4-0.3 3.3 5.1-0.9 3.6-4.6 4.2-4.7 3.2 2.1-2.1 3.7-4.2 1.4-8.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaviconLogo);
export default __webpack_public_path__ + "static/media/favicon-logo.1ac5a05eac0b6ccdfe45e63bea360936.svg";
export { ForwardRef as ReactComponent };